/**
 * G9. Чемодан: 8 вещей, взять 4; эффекты написаны прямо на вещах.
 * «В дорогу» — ехать с собранным, «Остаться» — отказаться от переезда.
 */
import { t } from '@life/i18n';
import type { SuitcaseInput, SuitcaseState } from '@life/minigames';
import { useState } from 'preact/hooks';
import type { MinigameScreenProps } from './types';
import { Pick } from './ui/Pick';

export function Suitcase({ state, onInput }: MinigameScreenProps<SuitcaseInput, SuitcaseState>) {
  const [picks, setPicks] = useState<number[]>([]);
  return (
    <>
      <p class="hint">{t('ui.minigame.suitcase.rules', { n: state.picks, total: state.items.length })}</p>
      <Pick
        label={t('ui.minigame.suitcase.label')}
        items={state.items.map((it) => ({ text: t(it.key), ...(it.effectKey ? { note: t(it.effectKey) } : {}) }))}
        max={state.picks}
        value={picks}
        onChange={setPicks}
      />
      <div class="picks">
        <button type="button" class="btn accent" disabled={picks.length < state.picks} onClick={() => onInput({ picks })}>
          {t('ui.minigame.suitcase.go')}
        </button>
        <button type="button" class="btn" onClick={() => onInput({ picks: [], stay: true })}>
          {t('ui.minigame.suitcase.stay')}
        </button>
      </div>
    </>
  );
}
